<template>
    <div class="disable-scroll-x bg-white">
        <div>
            <CRow class="ml-5 mr-5 mb-5">
                <Mainlayout></Mainlayout>
                <br /><br /><br />
            </CRow>
    
           
            <CRow class="justify-content-center m-0">
                <div style="background: #fff">
                    <CContainer>
                        <div>
                            <CRow>
                                <CCol sm="12">
                                    <div class="text-center m-0">
    
                                        <div class="text-center mt-5">
                                            <!-- <img style="max-width:100%;border-radius:10px" src="../assets/img/bigclass.jpeg"/> -->
    
                                            <CCarousel arrows indicators animate loop max-height="200px" class="mt-5" interval="3000">
                                                <CCarouselItem captionHeader="Blank page" captionText="Nulla vitae elit libero, a pharetra augue mollis interdum.">
                                                    <img src="../assets/img/12.png" style="max-width:60%" /></CCarouselItem>
                                                <CCarouselItem>
                                                    <img src="../assets/img/2 (1).png" style="max-width:60%" />
                                                </CCarouselItem>
                                                <CCarouselItem>
                                                    <img src="../assets/img/3.png" style="max-width:60%" />
                                                </CCarouselItem>
                                                <CCarouselItem>
                                                    <img src="../assets/img/4 2.png" style="max-width:60%" />
                                                </CCarouselItem>
                                            </CCarousel>
                                            <CButton type="button" color="primary" class="btn custom-btn-login-forgot btn-info m-1 mt-2" @click="OpenSignUpUserAffiliate()">Register</CButton>
    
                                        </div>
                                        <br />
                                        <br />
    
                                        <br />
    

                                    </div>
                                </CCol>
                                <!-- <CCol sm="6">
                                    <CContainer class="text-left mt-4">
                                            <div v-if="this.ErrorPopup === true" class="">
                                                <CAlert show color="danger">Error to Register.Please check form.
                                                </CAlert>
                                            </div>
    
                                            <div v-if="this.SuccessPopup === true" class="">
                                                <CAlert show color="success">Successfully to register BigClassRoom
                                                    <div style="clear:both"></div>
                                                    <br />
                                                   
                                                </CAlert>
                                            </div>
    
    
    
                                            <div v-if="detailForm === true">
    
                                                <h1 class="
                                      mt-3
                                      mb-4
                                      custom-24px
                                      d-sm-down-none
                                      text-left text-dark
                                    ">
                                    <strong>Registration Prestige Class Room</strong>
                                                </h1>
    
                                                <h5 class="mb-4 d-md-none text-dark text-left">
                                                    <strong>Registration Prestige Class Room</strong>
                                                </h5>
                                                <label class="text-black">Fill up the form following below</label>
    
    
                                                <CRow>
                                                    <CCol sm="12">
                                                        Name
                                                        <br />
                                                        <input type="text" v-model="Name" class="custom-input-app" placeholder="Your Name"/>
                                                    </CCol>
                                                    <CCol sm="12" class="mt-2">
                                                        Email
                                                        <br />
                                                        <input type="text" v-model="Email" class="custom-input-app"  placeholder="Your Email" />
                                                    </CCol>

                                                    <CCol sm="12" class="mt-2">
                                                        Password
                                                        <br />
                                                        <input type="text" v-model="PasswordHash" class="custom-input-app"  placeholder="Your Password" />
                                                    </CCol>
    
                                                    <CCol sm="12" class="mt-2">
                                                        Phone
                                                        <br />
                                                        <input type="text" v-model="Phone" class="custom-input-app"  placeholder="Your Phone"/>
                                                    </CCol>
                                                    <CCol sm="12" class="mt-2">
                                                        Grade
                                                        <br />
                                                        <v-select v-model="SelectedGrade" :options="grades" label="GradeName" placeholder="--Please Select Grade--" required></v-select>
     </CCol>
    
    
                                                    <br />
                                                    <br />
                                                    <CButton type="button" color="primary" class="btn custom-btn-login-forgot btn-info m-1 mt-2" @click="SubmitPromo" block>Pay and Register</CButton>
    
                                                    <br />
                                                </CRow>
                                            </div>
    
    
                                    </CContainer>
                                </CCol> -->
                            </CRow>
                        </div>
                    </CContainer>
                </div>
            </CRow>
            <div>
                <div style="background: #fff;">
                    <CContainer>
                        <CRow>
                            <CCol sm="12">
                                <h3 class="mt-4 mb-2">Terma Dan Syarat</h3>
                                <p>
                                    <strong>Bayaran Pendaftaran:</strong>
                                    <br /> Bayaran pendaftaran sebanyak <strong class="text-blue">RM 10.00</strong> diperlukan untuk mengesahkan pendaftaran anda.
                                    <br /><br />
                                    <strong>Kelayakan untuk Cabutan Bertuah - Lucky Draw</strong>
                                    <br /> Semua pendaftar yang berjaya membuat bayaran pendaftaran adalah layak untuk mengambil bahagian dalam cabutan bertuah. Sebuah laptop (chromebook) akan diberikan sebagai hadiah cabutan bertuah kepada <strong class="text-blue">pendaftar yang ke-20, ke-50, ke-100, ke-200, dan ke-500.</strong>

                                    <br /><br />
    
    
    
                                    <strong>Kelayakan untuk Cabutan Bertuah - Grand Lucky Draw</strong>
                                    <br /> <strong class="text-blue">500 orang pendaftar</strong> yang berjaya membuat bayaran pendaftaran dan melanggan mana-mana pakej dalam masa satu bulan adalah layak untuk mengambil bahagian dalam cabutan bertuah Grand Lucky Draw ini. <strong class="text-blue">Sebuah ipad (pensil + keyboard)</strong> akan diberikan sebagai hadiah.
                                    <br /><br />
                                    <strong>Pembahagian Hadiah</strong>
                                    <br />Pemenang cabutan bertuah akan dimaklumkan melalui maklumat hubungan yang diberikan semasa pendaftaran. Cara dan jadual pembahagian hadiah akan dimaklumkan kepada pemenang.

                                    <br /><br />
    
                                  
                                    <br /><br />
                                    <div v-if="showMessage">
                                        <strong>Bayaran Tidak Boleh Dipulangkan</strong> <br />
                                        Sila ambil perhatian bahawa semua bayaran yang dibuat untuk pendaftaran adalah tidak dikembalikan. <br /><br />
                                        
                                        <strong>Syarat Penyertaan</strong> 
                                        <br />Dengan membuat bayaran pendaftaran, anda bersetuju untuk mematuhi peraturan dan syarat yang ditetapkan untuk penyertaan dalam cabutan bertuah.<br
                                        /><br />
                                        <strong>Tarikh Cabutan</strong> 
                                        <br />Tarikh cabutan bertuah akan dimaklumkan secara berasingan. Peserta dinasihatkan untuk kekal mengemaskini untuk pengumuman mengenai cabutan.<br /><br />
                                        
                                        <strong>Ketetapan Akhir</strong> 
                                        <br />Semua keputusan mengenai cabutan bertuah, termasuk tetapi tidak terhad kepada pemilihan pemenang, peruntukan hadiah, dan penolakan peserta, akan berada di bawah budi bicara jawatankuasa penganjur dan akan dianggap muktamad.
 <br /><br />
                                        
 <strong>Liabiliti</strong> <br />
  Jawatankuasa penganjur tidak akan bertanggungjawab atas sebarang kegagalan teknikal, ralat, atau masalah lain yang mungkin mempengaruhi penyertaan dalam cabutan bertuah.

                                        <br /><br />
                                        <strong>Pindaan Terma
 </strong>
 <br />Jawatankuasa penganjur berhak untuk meminda, menggantung, atau menghentikan cabutan bertuah atau sebarang aspek yang berkaitan, atas budi bicara mereka, tanpa notis terlebih dahulu.


 <br /><br />
                                        <strong>Penerimaan Terma

 </strong>
 <br />Dengan membuat bayaran pendaftaran, anda mengakui bahawa anda telah membaca, memahami, dan bersetuju untuk mematuhi terma dan syarat ini.
 <br /><br />
 <p>Sila pastikan bahawa anda menyemak dengan teliti terma dan syarat ini sebelum meneruskan dengan pendaftaran anda. Jika anda mempunyai sebarang soalan atau kebimbangan, jangan ragu untuk menghubungi kami.
</p>

    
    
                                    </div>

                                    <CButton color="info" class="custom-btn-login-active-signin mt-2 mb-5 btn-info" @click="toggleMessage">
                                        {{ buttonText }}
                                    </CButton>
    
                                </p>
                            </CCol>
                        </CRow>
                    </CContainer>
                </div>
            </div>
    
        </div>
    
        <Footerlayout></Footerlayout>
    </div>
</template>
          
          
          
          
<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import AnimatedNumber from "animated-number-vue";
import backgroundBanner from "../assets/img/promodesign.png";

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

import VueAgile from "vue-agile";
Vue.use(VueAgile);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import _ from "lodash";
new Vue({
    el: "#navbar",

    data() {
        return {
            view: {
                topOfPage: true,
            },
          
        };
    },
    beforeMount() {
        window.addEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            if (window.pageYOffset > 400) {
                if (this.view.topOfPage) {
                    this.view.topOfPage = false;
                    el.setAttribute(
                        "style",
                        "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
                    );
                }
            } else {
                if (!this.view.topOfPage) this.view.topOfPage = true;
                el.setAttribute(
                    "style",
                    "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
                );
            }
        },
    },
});
export default {
    name: "Login",
    components: {
        Mainlayout,
        Footerlayout,
    },
    data() {
        return {
            Name: "",
            Email: "",
            Phone: "",
            Code: "",
            Grade: "",
            SchoolName: "",
            PasswordHash: "",
            SuccessPopup: false,
            ErrorPopup: false,

            SelectedGrade: "",
            grades: [],
            detailForm: true,
            loop: "",
            showMessage: false,
            buttonText: 'Lihat Lebih Lanjut'
        };
    },
    created() {
        AOS.init();
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll);

        if (window.location.hostname !== 'www.pickiddo.com/edtournament') {
            window.location.href = 'https://www.pickiddo.com/edtournament'
        }
    },
    async mounted() {
        this.GetGrade();
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll);
    },
    computed: {},

    methods: {

      toggleMessage() {
            this.showMessage = !this.showMessage;
            this.buttonText = this.showMessage ? 'Sembunyikan Butiran' : 'Lihat Lebih Lanjut';
        },
        getBadge(status) {
            switch (status) {
                case "Active":
                    return "success";
                case "Inactive":
                    return "secondary";
                case "Pending":
                    return "warning";
                case "Banned":
                    return "danger";
                default:
                    "primary";
            }
        },
        onScroll() {
            // Get the current scroll position
            const currentScrollPosition =
                window.pageYOffset || document.documentElement.scrollTop;
            // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
            if (currentScrollPosition < 0) {
                return;
            }
            // Here we determine whether we need to show or hide the navbar
            this.showNavbar = currentScrollPosition < this.lastScrollPosition;
            // Set the current scroll position as the last scroll position
            this.lastScrollPosition = currentScrollPosition;
        },
        handleScroll() {
            if (window.pageYOffset > 1000) {
                if (this.view.topOfPage) {
                    this.view.topOfPage = false;
                } else {
                    this.view.topOfPage = true;
                }
            }
        },
        GetGrade() {
            this.$API
                .get(this.$ListGrade, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.grades = response.data;
                    }
                });
        },
        async SubmitPromo() {
            if (
                this.Name == "" ||
                this.Email == "" ||
                this.Phone == ""
            ) {
                this.ErrorPopup = true;
            } else {
                const hasCodeAff = this.$route.query.hasOwnProperty('aff');
                this.Busy = true;
                this.detailForm = false;
                const formData = new FormData();

                formData.append("Email", this.Email);
                formData.append("Name", this.Name);
                formData.append("Phone", this.Phone);
                formData.append("Grade", this.SelectedGrade.GradeName);
                formData.append("GradeId", this.SelectedGrade.Id);
                if (hasCodeAff) {
                    formData.append("CodeAff", this.$route.query.aff);
                }
                formData.append("PasswordHash", this.PasswordHash);
                formData.append("UserType", "Student");

                return this.$API
                    .post(this.$InsertRegisterBigClassRoom, formData, {})
                    .then((response) => {
                        if (response.status == 200) {
                            this.SuccessPopup = true;
                            //window.open("https://www.billplz.com/pickiddobigclass");
                        } else {
                            this.Busy = false;
                            this.$dialog
                                .alert("Error to create packagess")
                                .then(function() {});
                        }
                    })
                    .catch((error) => {
                        this.Busy = false;
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
            }
        },
        GoToApp() {
            this.detailForm = false;
            this.$router.push("DownloadApp");
        },
        OpenSignUpUserAffiliate()
        {
            const hasCodeAff = this.$route.query.hasOwnProperty('aff');
            if (hasCodeAff) {
            this.$router.push("SignUpUserAffiliate?aff=" + this.$route.query.aff);
            }
            else
            {
                this.$router.push("SignUpUserAffiliate");

            }
        }
    },
};
</script>
              <<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
.c-header {
    /* background: rgb(23, 77, 124);
            background: linear-gradient(92deg, #174d7c, #1b7682);
            border-bottom: 0.01px solid #1a6783;
            border-bottom: 1px solid #636f83; */
            background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    border-bottom: 0;
    border-bottom: 0;
    /* color: #fff; */
}

.c-app {
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
    font-family: 'Montserrat', sans-serif;
}

body {
    font-family: "Montserrat", sans-serif;
    background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
    font-family: "Montserrat", sans-serif;
}

label {
    font-family: "Montserrat", sans-serif;
}

body nav.onScroll {
    box-shadow: 0 0 10px #aaa;
    background-color: rgb(255, 255, 255);
    font-family: 'Montserrat';
    font-style: normal;
}

body nav.onScroll ul li {
    color: #10b761;
}

body nav ul {
    margin-left: 3em;
    width: 25%;
    display: flex;
    justify-content: space-between;
}

body nav ul li {
    cursor: pointer;
    font-weight: 600;
    list-style-type: none;
    color: white;
}

body {
    top: 0 !important;
    font-family: 'Montserrat', sans-serif;
}


</style>